const Footer = () => {
    return (
      <footer className="fixed bottom-0 left-0 w-full bg-gray-900 z-50 text-white text-center py-2 text-xs md:text-sm">
        The Emoji Wall © 2025. Limited spots available! We are not responsible for external content. Emojis and trademarks belong to their respective owners.
      </footer>
    );
  };
  
  export { Footer };
  